var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"threadsTrigger"},_vm._l((_vm.count),function(num){return _c('div',{key:num},[_c('v-skeleton-loader',{attrs:{"type":"list-item-avatar-two-line"}}),_c('v-divider')],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }